import { useEffect, useRef, useState } from "react";
import ExpandableFormList from "../gdk/ExpandableForm/ExpandableFormList";
import ExpandableFormListItem from "../gdk/ExpandableForm/ExpandableFormListItem";
import AgencyBranchesForm from "./AgencyBranchesForm";
import { GdkMultipleSelectBox } from "@gdk/multiple-select-box";
import $ from 'jquery';
import { searchAgencies } from "../../api/search";

export default function AgencyBranches({
    parentAgencyId,
    selectedBranchId
}) {
    const [agencyBranches, setAgencyBranches] = useState([]);
    const [selectedAgencyBranch, setSelectedAgencyBranch] = useState({});
    const [selectedAgencyBranchId, setSelectedAgencyBranchId] = useState(selectedBranchId);
    const [expandableForm, setExpandableForm] = useState();
    const [isNewBranch, setIsNewBranch] = useState(false);
    const scrollViewRef = useRef();

    const agencyBranchSelectBoxRef = useRef();

    const onAgencyBranchSelectBoxChange = () => {
        setSelectedAgencyBranchId(agencyBranchSelectBoxRef.current.value);
    };

    useEffect(() => {
        new GdkMultipleSelectBox({
            "content": "#agency-branches-select-box"
        });

        $("#agency-branches-select-box").on("change", onAgencyBranchSelectBoxChange);
    }, []);

    useEffect(() => {
        searchAgencies({ parentAgencyId: parentAgencyId, isBranch: true }, response => setAgencyBranches(response));
    }, []);

    useEffect(() => {
        let selectedBranch = agencyBranches.find(b => b.agencyId === selectedAgencyBranchId) ?? {};
        setSelectedAgencyBranch(selectedBranch);
        setIsNewBranch(Object.keys(selectedBranch)?.length === 0)
    }, [selectedAgencyBranchId, agencyBranches]);

    useEffect(() => {
        if (selectedBranchId) {
            $("#agency-branches-select-box").val(selectedBranchId).trigger("change");
        }

        setSelectedAgencyBranchId(agencyBranchSelectBoxRef.current.value);
    }, [agencyBranches]);

    const agencyBranchesSummary = (selectedAgencyBranch) => [
        { name: "Number of Centers under same EIN", value: selectedAgencyBranch ? agencyBranches?.length : "" },
        { name: "Branch Name", value: selectedAgencyBranch?.name },
        { name: "Branch Address", value: AddressString(selectedAgencyBranch?.businessAddress) },
        { name: "Contact", value: `${selectedAgencyBranch?.branchContact?.firstName ?? ""} ${selectedAgencyBranch?.branchContact?.lastName ?? ""}` },
        { name: "Role", value: selectedAgencyBranch?.branchContact?.role },
        { name: "Email", value: selectedAgencyBranch?.branchContact?.email },
        { name: "Branch Phone Number", value: selectedAgencyBranch?.branchContact?.branchOfficePhone }
    ];

    const AddNewBranch = () => {
        $("#agency-branches-select-box").val("Select Branch").trigger("change");
        setIsNewBranch(true);
        expandableForm?.openForm(document.getElementById("agency-branch-form-li"));
        scrollViewRef.current.scrollIntoView({ behavior: 'smooth' });
    }

    return <>
        {(agencyBranches == null || agencyBranches?.length === 0) &&
            <div id="alert-low" className="alert">
                <div className="alert--low-importance">
                    <span className="icon-alert" />
                    <ul className="alert-list">
                        <li className="alert-content">
                            <div className="h4">No Branches Available</div>
                            <p>
                                Your agency does not have any branches.
                            </p>
                            {/* 
                                TODO: Uncomment the following line and update link to more information
                                <a href="/alert">More Information</a> 
                            */}
                        </li>
                    </ul>
                </div>
            </div>
        }
        <div hidden={!agencyBranches?.length > 0}>
            <div ref={scrollViewRef} />
            <div className="form-field">
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <label htmlFor="agency-branches-select-box" className="text">Select an Agency Branch</label>
                    <label htmlFor="agency-branches-select-box" className="text"
                        style={{
                            textDecorationLine: "underLine",
                            color: "#005CCC"
                        }}
                        onClick={AddNewBranch}>
                        Add a New Branch
                    </label >
                </div>
                <div>
                    <select id="agency-branches-select-box" ref={agencyBranchSelectBoxRef} onChange={onAgencyBranchSelectBoxChange} disabled={!agencyBranches}>
                        <option>Select Branch</option>
                        {agencyBranches
                            ?.sort((a, b) => a.name?.localeCompare(b.name))
                            ?.map(branch =>
                                <option value={branch?.agencyId} key={branch?.agencyId}>
                                    {`${branch?.agencyId} - ${branch?.name} `}
                                </option>
                            )
                        }
                    </select>
                </div>
            </div>
            <ExpandableFormList setExpandableForm={setExpandableForm}>
                <ExpandableFormListItem
                    id="agency-branch-form-li"
                    headline={selectedAgencyBranch?.name}
                    subHeadline={selectedAgencyBranch?.agencyId}
                    subtext={selectedAgencyBranch?.businessAddress?.street1}
                    editable={true}
                    summaryItems={agencyBranchesSummary(selectedAgencyBranch)}
                    form={<AgencyBranchesForm
                        parentAgencyId={parentAgencyId}
                        agencyBranch={selectedAgencyBranch}
                        setAgencyBranch={setSelectedAgencyBranch}
                        isNewBranch={isNewBranch}
                        setIsNewBranch={setIsNewBranch}
                        expandableForm={expandableForm}
                    />}
                />
            </ExpandableFormList>
        </div>
    </>;
};

const AddressString = (a) => a ? `${a.street1}, ${a.city}, ${a.state}, ${a.zipCode}` : "";